import React from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { StoreState } from 'types';

import Fallback from 'components/fallback/fallback';
import Error500 from 'pages/Error500';
import Error403 from 'pages/Error403';

const Login = React.lazy(() => import('pages/Login'));
const Dashboard = React.lazy(() => import('pages/Dashboard'));
const Cumulative = React.lazy(() => import('pages/Cumulative'));

function App() {
  const { token } = useSelector((state: StoreState) => state.login);
  
  return (
    <BrowserRouter>
        <Routes>
          {token 
            ? <>
                <Route element={<Error500 />} path="/secured/500" />
                <Route element={<Error403 />} path="/secured/403" />
                <Route element={<React.Suspense fallback={<Fallback />}><Dashboard /></React.Suspense>} path="/secured/dashboard" />
                <Route element={<React.Suspense fallback={<Fallback />}><Cumulative /></React.Suspense>} path="/secured/cumulative" />
                <Route path="*" element={<Navigate replace to="/secured/dashboard" />} />
            </> 
            : <>
                <Route element={<React.Suspense fallback={<Fallback />}><Login /></React.Suspense>} path="/" />
                <Route path="*" element={<Navigate replace to="/" />} />
              </>
          }
        </Routes>
    </BrowserRouter>
  );
}

export default App;
